import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';

import ChartMenu from './../ChartMenu/ChartMenu'
// import CustomTooltip from './NegativeTooltip';
import BarsComponent from './BarsComponent'
import SelectComponent from './SelectComponent';

import './topStyle.css';

import { colors, colors1, colors2, colors3, colors4, colors5 } from '../../../../constants/icons/characteristics/Characteristics';

class TopComponent extends Component {
  constructor(props) {
    super(props);
    let datos = [];
    var tops = [];
    const bars = props.cantBars ? props.cantBars : 5
    if (props.data.length > bars - 1) {
      for (let i = 0; i < bars; i++) {
        datos.push(props.data[i]);
      }
    } else {
      datos = props.data;
    }
    for (let i = 0; i <= props.data.length; i += bars) {
      tops.push({ name: (i + 1) + ' - ' + (i + bars), value: i });
    }
    this.state = {
      data: datos,
      tops,
      range: 0,
      characteristic: 0,
      colors: colors5
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // only update chart if the data has changed
    if (prevProps.data !== this.props.data) {
      let datos = [];
      var tops = [];
      const bars = prevProps.cantBars ? prevProps.cantBars : 5

      if (this.props.data.length > bars - 1) {
        for (let i = 0; i < bars; i++) {
          datos.push(this.props.data[i]);
        }
      } else {
        datos = this.props.data;
      }
      for (let i = 0; i <= this.props.data.length; i += bars) {
        tops.push({ name: (i + 1) + ' - ' + (i + bars), value: i });
      }
      this.setState({
        data: datos,
        tops,
        range: 0,
        characteristic: 0
      });

    }
  }

  onChangeColor = (color) => {
    if (color === 'Verde') {
      this.setState({ colors: colors })
    } else if (color === 'Rojo') {
      this.setState({ colors: colors1 })
    } else if (color === 'Verde-Azul') {
      this.setState({ colors: colors2 })
    } else if (color === 'Gris') {
      this.setState({ colors: colors3 })
    } else if (color === 'Azul') {
      this.setState({ colors: colors4 })
    } else if (color === 'Policromático') {
      this.setState({ colors: colors5 })
    }
  }

  handleChangeItem = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i].value;
    }
    return resp;
  }

  getItems = () => {
    return this.state.data.map((val, i) => {
      return (
        <MenuItem value={i}>{val.name}</MenuItem>
      )
    })
  }

  changeCharacteristics = (val) => {
    if (typeof this.props.data[val.target.value] !== "undefined") {
      this.setState({ data: [this.props.data[val.target.value]] });
    } else {
      let datos = [];
      const bars = this.props.cantBars ? this.props.cantBars : 5
      if (this.props.data.length > bars - 1) {
        for (let i = 0; i < bars; i++) {
          datos.push(this.props.data[i]);
        }
      } else {
        datos = this.props.data;
      }
      this.setState({ data: datos });
    }
  }

  changeTops = (val) => {
    let { data } = this.props;
    var top = [];
    const bars = this.props.cantBars ? this.props.cantBars : 5
    for (let i = val.target.value * bars; i < (val.target.value * bars) + bars; i++) {
      try {
        if (typeof data[i] !== "undefined")
          top.push(data[i]);
      } catch (e) { }
    }
    this.setState({ data: top });
  }

  getDate = () => {
    try {
      return (
        <Grid container>
          <Grid item xs={12} className="text-center client-label-second-color font-12">
            Actulizado a: {this.props.date.split('T')[0]}
          </Grid>
        </Grid>
      )
    } catch (e) { }
  }

  render() {
    return (
      <Grid container>
        <Grid style={{ flexWrap: "inherit", }} id={this.props.name} >
          <ChartMenu
            graph={this.props.name}
            file={this.props.title}
            title={this.props.title.toLowerCase() === 'iep' ? 'Inspectores': this.props.title}
            watch={this.props.watchMenu}
            openDialog={this.props.openDialog}
            seeMore={this.props.seeMore}
            seeTen={this.props.seeTen}
            changeColor={true}
            onChangeColor={this.onChangeColor} />
          <Grid container>
            {
              <BarsComponent
                data={this.state.data}
                onClickGraphic={this.props.onClickGraphic}
                name={this.props.name}
                colors={this.state.colors}
                total={this.getTotal()}
              />
            }
          </Grid>
        </Grid>
        {
          !this.props.noSelect &&
          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid item xs={4}>
              <SelectComponent
                data={this.props.data}
                onChange={this.changeCharacteristics}
                label={'Elementos'}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={4}>
              <SelectComponent
                data={this.state.tops}
                onChange={this.changeTops}
                label={'Tops'}
              />
            </Grid>
          </Grid>
        }
        {this.getDate()}
      </Grid>
    )
  }
}

export default TopComponent;
